import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';

import { faPenToSquare, faUser } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function Zusammenfassung() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-start lg:flex-row gap-8 p-4 md:p-0">
      <div className="md:w-96 w-full">
        <Card className="p-5 bg-neutrals-100 rounded-3xl shadow-lg">
          <div className="flex flex-col gap-3">
            <Avatar className="size-16">
              <AvatarFallback>
                <FontAwesomeIcon icon={faUser} className="size-5" />
              </AvatarFallback>
            </Avatar>
            <div className="flex flex-col gap-2">
              <div className="flex gap-2 items-center justify-between">
                <h2 className="text-neutrals-900 text-xl font-bold leading-7 wrap-break-word">
                  Max Mustermann
                </h2>
                <Button variant={'icon'}>
                  <FontAwesomeIcon
                    icon={faPenToSquare}
                    className="text-primary-blue-600"
                  />
                </Button>
              </div>
              <div className="flex flex-col gap-1">
                <span className="text-neutrals-800 text-sm font-normal leading-5">
                  {t('domain.mitarbeiter.create.allgemeinForm.anrede.label')}
                </span>
                <span className="text-neutrals-900 text-sm font-semibold leading-5">
                  Mann
                </span>
              </div>
            </div>
          </div>
        </Card>
      </div>
      <div className="grow"></div>
    </div>
  );
}
